import SEO from "../../../../src/components/seo";
import HeroPages from "../../../../src/components/heroes/hero-pages";
import { Container } from 'react-bootstrap';
import React from 'react';
export default {
  SEO,
  HeroPages,
  Container,
  React
};